import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DotGrid from './components/DotGrid';

function App() {
  return (
    <div>
      <DotGrid 
        dotSize={10}
        gap={15}
        baseColor="#0d0014"
        activeColor="#8100cc"
        proximity={120}
        shockRadius={250}
        shockStrength={5}
        resistance={750}
        returnDuration={1.5}
      />

      <div style={{ zIndex: 5 }}>
        <Header />
        <Hero />
        <About />
        <Services />
        <Projects />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}



export default App;

